import $ from "jquery";
import { View } from "backbone";

export default class OuterView extends View {
  initialize() {
    this.makeRoomForFooter();
    $(window).on("resize", this.makeRoomForFooter.bind(this));
  }

  // This is a JS-implentation of a FooterStick
  // https://css-tricks.com/couple-takes-sticky-footer/
  //
  // This measures the window viewport height.
  // `this.$el` (which is #outer), get set a min-height that is
  // the viewport height minus the height of the topbar, header and footer elements,
  // (and the padding on #outer itself).
  //
  // This lets pages where the content doesn't fill 100% of the viewport height
  // the size needed to make the footer "stick" to _exactly_ the bottom of the
  // page, and for pages where the content is _taller_ than 100% viewport height,
  // we get normal element flow and scrollbars.
  makeRoomForFooter() {
    const outerEl = this.$el;
    const outerElPadding = parseInt(outerEl.css("padding-top"), 10);

    const topbarHeight = this.options.topbar.outerHeight() || 0;
    const headerHeight = this.options.header.outerHeight() || 0;
    const topbarHeaderHeight = topbarHeight + headerHeight;

    const footersHeight = this.options.footers.outerHeight() || 0;

    outerEl.css({ minHeight: $(window).height() - topbarHeaderHeight - footersHeight - outerElPadding });
  }
}
